<div
  class="flex size-full flex-row items-center gap-3 rounded-2xl bg-blue-veryLight px-6 py-5 text-center text-sm"
>
  <div
    class="flex size-10 shrink-0 items-center justify-center rounded-full bg-white pb-1"
  >
    <mat-icon class="text-xl text-blue">question_answer</mat-icon>
  </div>
  <div class="flex flex-col text-left">
    <span class="font-semibold">
      {{ 'product.dialog.help.text' | transloco }}
    </span>
    <app-text-button [showOutline]="true" (click)="onSupportButtonClick()">
      {{ 'product.dialog.help.button' | transloco }}
    </app-text-button>
  </div>
</div>
